import React from 'react';

interface CompanyHeroProps {
    title: string;
    subtitle: string;
    showLogo?: boolean;
    logoFilter?: string;
    className?: string;
}

const CompanyHero: React.FC<CompanyHeroProps> = ({
    title,
    subtitle,
    showLogo = true,
    logoFilter = 'brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(1574%) hue-rotate(212deg) brightness(91%) contrast(101%)',
    className = ''
}) => {
    return (
        <section className={`relative px-4 py-12 ${className}`}>
            <div className="max-w-6xl mx-auto text-center">
                {/* Logo Section */}
                {showLogo && (
                    <div className="mb-12 animate-fade-in-down">
                        <div className="flex justify-center items-center">
                            <img 
                                src="/branding/logo_blue.svg" 
                                alt="Hush" 
                                style={{
                                    width: '164px',
                                    height: '75px',
                                    objectFit: 'contain',
                                    filter: logoFilter
                                }}
                            />
                        </div>
                    </div>
                )}

                {/* Main Title Section */}
                <h1 
                    className="animate-fade-in-up"
                    style={{
                        fontFamily: 'Manrope',
                        fontWeight: 700,
                        fontSize: 'clamp(32px, 4vw, 48px)',
                        lineHeight: '110%',
                        letterSpacing: '-0.02em',
                        color: '#2563EB',
                        marginBottom: '16px',
                        animationDelay: '0.2s'
                    }}
                >
                    {title}
                </h1>

                {/* Subtitle Section */}
                <p 
                    className="animate-fade-in-up"
                    style={{
                        fontFamily: 'Manrope',
                        fontWeight: 400,
                        fontSize: 'clamp(16px, 2vw, 18px)',
                        lineHeight: '150%',
                        color: '#6B7280',
                        maxWidth: '600px',
                        margin: '0 auto',
                        animationDelay: '0.4s'
                    }}
                >
                    {subtitle}
                </p>
            </div>
        </section>
    );
};

export default CompanyHero;
